import Link from 'next/link'
import { FC } from 'react'

import { ArrowLinkIPort } from '@/shared/lib/@deprecated/iport-icons'

import cl from './InfoCloud.module.scss'

export interface Link {
	text: string
	href: string
}

export interface Props {
	text: string
	link?: Link
}

export const ArrowLink: FC<{ link: Link }> = ({ link }) => {
	return (
		<Link prefetch={false} href={link.href} className={cl.infoCloud__link}>
			<span className={cl.infoCloud__linkContentWrapper}>
				<span className={cl.infoCloud__linkText}>{link.text}</span>
				<ArrowLinkIPort width={18} height={18} className={cl.infoCloud__linkIcon} />
			</span>
		</Link>
	)
}

const InfoCloud: FC<{ data: Props }> = ({ data }) => {
	return (
		<span className={cl.infoCloud}>
			<span className={cl.infoCloud__text}>{data.text}</span>
			{!!data.link && <ArrowLink link={data.link} />}
		</span>
	)
}

export default InfoCloud
